var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1015)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 10.6001C17.451 10.6001 19.6 12.7491 19.6 15.4001H7.60002C7.60002 12.7491 9.74906 10.6001 12.4 10.6001H14.8ZM7.60002 10.6001C7.96097 10.6001 8.31261 10.6399 8.65079 10.7155C7.27866 11.815 6.40002 13.505 6.40002 15.4001H0.400024C0.400024 12.7491 2.54906 10.6001 5.20002 10.6001H7.60002ZM14.8 11.8001H12.4C10.8326 11.8001 9.49908 12.8019 9.00487 14.2001H18.1952C17.701 12.8019 16.3675 11.8001 14.8 11.8001ZM6.16315 11.8001H5.20002C3.63256 11.8001 2.29907 12.8019 1.80487 14.2001H5.29995C5.44332 13.3473 5.73783 12.5361 6.16315 11.8001ZM6.40002 4.6001C7.72551 4.6001 8.80002 5.67461 8.80002 7.0001C8.80002 8.32558 7.72551 9.4001 6.40002 9.4001C5.07454 9.4001 4.00002 8.32558 4.00002 7.0001C4.00002 5.67461 5.07454 4.6001 6.40002 4.6001ZM13.6 4.6001C14.9255 4.6001 16 5.67461 16 7.0001C16 8.32558 14.9255 9.4001 13.6 9.4001C12.2745 9.4001 11.2 8.32558 11.2 7.0001C11.2 5.67461 12.2745 4.6001 13.6 4.6001ZM6.40002 5.8001C5.73728 5.8001 5.20002 6.33736 5.20002 7.0001C5.20002 7.66284 5.73728 8.2001 6.40002 8.2001C7.06277 8.2001 7.60002 7.66284 7.60002 7.0001C7.60002 6.33736 7.06277 5.8001 6.40002 5.8001ZM13.6 5.8001C12.9373 5.8001 12.4 6.33736 12.4 7.0001C12.4 7.66284 12.9373 8.2001 13.6 8.2001C14.2628 8.2001 14.8 7.66284 14.8 7.0001C14.8 6.33736 14.2628 5.8001 13.6 5.8001Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersSquare);
export default __webpack_public_path__ + "static/media/users-square.bddd13bb.svg";
export { ForwardRef as ReactComponent };